import {
  type Icon,
  ProhibitInsetIcon,
  WarningCircleIcon,
  XCircleIcon,
} from "@phosphor-icons/react";

export type AssetTradingStatus =
  | "overnight_not_supported"
  | "overnight_halted"
  | "not_tradable";

const STATUS_CONFIG: Record<
  AssetTradingStatus,
  {
    icon: Icon;
    message: string;
  }
> = {
  overnight_not_supported: {
    icon: ProhibitInsetIcon,
    message: "Overnight trading is not supported for this asset.",
  },
  overnight_halted: {
    icon: WarningCircleIcon,
    message: "Overnight trading is temporarily suspended for this asset.",
  },
  not_tradable: {
    icon: XCircleIcon,
    message: "This asset cannot be traded on our platform at this time.",
  },
};

interface AssetTradingStatusBadgeProps {
  status: AssetTradingStatus;
}

export const AssetTradingStatusBadge = ({
  status,
}: AssetTradingStatusBadgeProps) => {
  const { icon: Icon, message } = STATUS_CONFIG[status];

  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-[#565656] bg-[rgba(215,215,215,0.24)] px-2 py-1">
      <Icon size={16} className="shrink-0 text-[#565656]" />
      <span className="font-medium text-[#565656] text-xs leading-4">
        {message}
      </span>
    </div>
  );
};

export { STATUS_CONFIG };
